const RegiaoOptions = [
  { id: 1, text: "São Paulo", value:"SP" },
  { id: 2, text: "Brasília", value:"BSB" },
];

export { RegiaoOptions };
